import { Camera, Clock, Mail, PhoneCall } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ContactButtons } from "@/components/site/ContactButtons";
import { CallbackForm } from "@/components/inquiry/CallbackForm";
import { EmailForm } from "@/components/inquiry/EmailForm";
import { DamageForm } from "@/components/inquiry/DamageForm";

const TABS = [
  { value: "callback", label: "Rückruf", icon: PhoneCall },
  { value: "email", label: "E-Mail", icon: Mail },
  { value: "damage", label: "Schaden melden", icon: Camera },
];

const trigger =
  "flex h-auto flex-col items-center gap-1 whitespace-normal rounded-lg px-1.5 py-2 text-[12.5px] font-bold leading-tight text-brand-ink transition-colors hover:text-brand-blue data-[state=active]:bg-white data-[state=active]:text-brand-blue data-[state=active]:shadow-sm";

export const InquiryBox = ({ defaultTab = "callback" }) => (
  <div
    data-testid="inquiry-box"
    className="inquiry-scroll overflow-hidden rounded-2xl bg-white shadow-lift ring-1 ring-black/5 lg:max-h-[calc(100vh-8rem)] lg:overflow-y-auto"
  >
    <div className="bg-brand-yellow px-5 py-4">
      <p className="text-lg font-bold leading-snug text-brand-anthracite">Kostenlose Ersteinschätzung</p>
      <p className="mt-0.5 flex items-center gap-1.5 text-sm font-semibold text-brand-anthracite/80">
        <Clock className="h-4 w-4" /> Antwort meist innerhalb von 30 Minuten
      </p>
    </div>
    <div className="space-y-4 p-5">
      <ContactButtons prefix="inquiry" />
      <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-wider text-slate-400">
        <span className="h-px flex-1 bg-slate-200" /> oder online <span className="h-px flex-1 bg-slate-200" />
      </div>
      <Tabs defaultValue={defaultTab}>
        <TabsList className="grid h-auto w-full grid-cols-3 gap-1 rounded-xl bg-brand-mist p-1">
          {TABS.map(({ value, label, icon: Icon }) => (
            <TabsTrigger key={value} value={value} className={trigger} data-testid={`inquiry-tab-${value}`}>
              <Icon className="h-4 w-4" /> {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent forceMount value="callback" className="mt-4 data-[state=inactive]:hidden"><CallbackForm /></TabsContent>
        <TabsContent forceMount value="email" className="mt-4 data-[state=inactive]:hidden"><EmailForm /></TabsContent>
        <TabsContent forceMount value="damage" className="mt-4 data-[state=inactive]:hidden"><DamageForm /></TabsContent>
      </Tabs>
    </div>
  </div>
);
